import dayjs from "dayjs"
import { jsPDF } from "jspdf";

import "resource/font/THSarabun-normal"
import "resource/font/THSarabun-bold"

import { branchNoText } from "utils/branchNoText";
import { printHeader } from "./pirntHeader";
// import { blue } from "@mui/material/colors";
// import { numberFormat } from "utils";
//{jobOrderData, shipmentData, jobOrdIds, fName, msData, isPrintDateTime}
export const printJobOrder = ({ printDataArr, msData }) => {

  console.log("printDataArr::", printDataArr)
  const companyData = msData.serverData.CompanyData

  const pageSize = [8.3, 11.7]; //half letter
  const contentHeaderSize = 13;
  const contentSize = 18;

  const startY = 0.4
  const startX = 0.5
  const lineHeight = 0.25




  const lineOffsetX = 0.05
  const lineOffsetY = 0.05
  const lineLenght = 2.5 - 0.7
  const lineLenght2x = 2.5 * 2 - 0.7
  const lineLenght3x = 2.5 * 3 - 0.7
  const colHeader1 = startX
  const colText1 = colHeader1 + 0.5
  const lineText1 = colText1 - lineOffsetX
  const colHeader2 = colHeader1 + 2.5
  const colText2 = colHeader2 + 0.7
  const lineText2 = colText2 - lineOffsetX
  const colHeader3 = colHeader2 + 2.5
  const colText3 = colHeader3 + 0.55
  const lineText3 = colText3 - lineOffsetX

  const allBoxWidth = 7.8

  const doc = new jsPDF({
    orientation: "portrait",
    unit: "in",
    format: pageSize
  });
  doc.setLineWidth(0.007)
  doc.setFont("THSarabun")

  const drawHeader = ({ startX, startY, jobOrderData, isPrintDateTime, title, subTitle }) => {
    let xPos = startX
    let yPos = startY
    printHeader({ jsPDFDoc: doc, companyData, startX: xPos, startY: yPos - 0.2 })
    yPos = startY
    xPos = 6.2
    const jobOrdTextX = 6.2
    doc.setFont("THSarabun", "bold")
    doc.setFontSize(contentSize + 5)
    doc.text(title, jobOrdTextX, yPos, { align: "left" })

    doc.setFont("THSarabun", "bold")
    doc.setFontSize(contentSize - 3)
    doc.text(subTitle, jobOrdTextX + 1.15, yPos)
    const yPosTopRight = yPos + lineHeight + 0.05
    yPos = yPosTopRight
    // doc.text("ประเภทงาน: ", xPos, yPos)
    // yPos += lineHeight //* 4/5
    doc.text("วันที่: ", xPos, yPos)
    yPos += lineHeight //* 4/5
    doc.text("เลขที่ใบงาน: ", xPos, yPos)
    yPos += lineHeight
    doc.text("ประเภทงาน: ", xPos, yPos)

    // const filteredContSts = (jobOrderData.ContStses || [])
    // .filter(cs => cs.DrvId === jobOrderData.DrvId && ![2, 4].includes(cs.ContStsId))
    // const contStsText = filteredContSts.length === 0 ? "" : `${filteredContSts.map(cs => cs.ContStsNm).join(", ")} ตู้/สินค้า`


    yPos = yPosTopRight
    doc.setFont("THSarabun", "normal")

    xPos += 0.8
    // doc.text(contStsText, xPos, yPos)
    // yPos += lineHeight//* 4/5
    let dateTime = null
    const contStses = jobOrderData.ContStses || []
    const contStsFiltered = contStses.filter(cs => cs.DrvId === jobOrderData.DrvId)
    if (contStsFiltered.find(cs => cs.ContStsId === 3)) {
      dateTime = jobOrderData.AptTm ? jobOrderData.AptTm : null
    } else if (contStsFiltered.find(cs => cs.ContStsId === 5)) {
      dateTime = contStsFiltered.find(cs => cs.ContStsId === 5).StsTm
    } else if (contStsFiltered.find(cs => cs.ContStsId === 1)) {
      dateTime = contStsFiltered.find(cs => cs.ContStsId === 1).StsTm
    } else {
      dateTime = jobOrderData.AptTm
    }
    if (dateTime) {
      const aptTm = dayjs(dateTime)
      let date = aptTm.format("DD/MM/YYYY")
      let time = aptTm.format("HH:mm")
      if (isPrintDateTime) {
        if (!isPrintDateTime.date) {
          date = ""
        }
        if (!isPrintDateTime.time) {
          time = ""
        }
      }
      if (time === "00:00") time = ""
      doc.text(`${date} ${time}`, xPos - 0.4, yPos)
    }
    yPos += lineHeight//* 4/5
    doc.setFontSize(contentSize + 5)
    doc.text(jobOrderData.JobOrdId?.toString() || "", xPos, yPos)
    doc.setFontSize(contentSize)
    yPos += lineHeight
    doc.text(jobOrderData.Shipment.ShpmTypNm || "", xPos, yPos)
    return yPos
  }

  const drawJobOrder = ({ startY, jobOrderData, shipmentData, lineHeightContent, licNm }) => {
    let yPos = startY


    const yPosContent = yPos + 0.4

    const contStsObj = jobOrderData.ContStses ? jobOrderData.ContStses.reduce((acc, cs) => {
      acc[cs.ContStsId] = cs
      return acc
    }, {}) : {}

    const sts2PlcMs = jobOrderData.Sts2POIId ? msData.poiObj[jobOrderData.Sts2POIId] || "" : ""
    const sts4PlcMs = jobOrderData.Sts4POIId ? msData.poiObj[jobOrderData.Sts4POIId] || "" : ""

    const isTake = contStsObj[1]?.DrvId && contStsObj[1]?.DrvId === jobOrderData.DrvId ? true : false
    const isSts2 = contStsObj[2]?.DrvId && contStsObj[2]?.DrvId === jobOrderData.DrvId ? true : false
    const isLoc = contStsObj[3]?.DrvId && contStsObj[3]?.DrvId === jobOrderData.DrvId ? true : false
    const isSts4 = contStsObj[4]?.DrvId && contStsObj[4]?.DrvId === jobOrderData.DrvId ? true : false
    const isRtn = contStsObj[5]?.DrvId && contStsObj[5]?.DrvId === jobOrderData.DrvId ? true : false
    // let takePlc = isTake ? `${jobOrderData.TakeDteSt ? "(" + dayjs(jobOrderData.TakeDteSt).format("DD/MM") + ") " : ""}${jobOrderData.TakePlc}` : ""
    let sts2Plc = isSts2 ? sts2PlcMs : ""
    if (isLoc && !isTake) {
      sts2Plc = sts2PlcMs
    }
    // let loc = isLoc ? `${jobOrderData.AptTm ? "(" + dayjs(jobOrderData.AptTm).format("DD/MM") + ") " : ""}${jobOrderData.Loc}` : ""
    let sts4Plc = isSts4 ? sts4PlcMs : ""
    if (isRtn && !isLoc) {
      sts4Plc = sts4PlcMs
    }
    // let rtnPlc = isRtn ? `${jobOrderData.RtnDteSt ? "(" + dayjs(jobOrderData.RtnDteSt).format("DD/MM") + ") " : ""}${jobOrderData.RtnPlc}` : ""

    const orderArr = []
    if (isTake) {
      orderArr.push(jobOrderData.TakePlc)
    }
    if (isSts2) {
      orderArr.push(sts2Plc)
    }
    if (isLoc) {
      if (!isTake && sts2PlcMs) {
        orderArr.push(sts2PlcMs)
      }
      orderArr.push(jobOrderData.Loc)
    }
    if (isSts4) {
      orderArr.push(sts4Plc)
    }
    if (isRtn) {
      if (!isLoc && sts4PlcMs) {
        orderArr.push(sts4PlcMs)
      }
      orderArr.push(jobOrderData.RtnPlc)
    }
    yPos = yPosContent
    doc.setFont("THSarabun", "bold")
    doc.setFontSize(contentHeaderSize)
    doc.text("ลูกค้า", colHeader1, yPos)
    doc.text("JOB No.", colHeader3, yPos)
    doc.setFont("THSarabun", "normal")
    doc.setFontSize(contentSize)
    const shortCusNms = doc.splitTextToSize(shipmentData.CusNm || "", 4.3)
    doc.text(shortCusNms[0], colText1, yPos)
    doc.text(shipmentData.JobNo || "", colText3, yPos)
    doc.line(lineText1, yPos + lineOffsetY, lineText1 + lineLenght2x, yPos + lineOffsetY)
    doc.line(lineText3, yPos + lineOffsetY, lineText3 + lineLenght, yPos + lineOffsetY)

    yPos += lineHeightContent
    doc.setFont("THSarabun", "bold")
    doc.setFontSize(contentHeaderSize)
    doc.text("รับตู้", colHeader1, yPos)
    doc.text("Agent", colHeader2, yPos)
    doc.text("Booking", colHeader3, yPos)
    doc.setFont("THSarabun", "normal")
    doc.setFontSize(contentSize)
    doc.text(jobOrderData.TakePlc || "", colText1, yPos)
    doc.text(shipmentData.Agnt || "", colText2, yPos)
    doc.text(shipmentData.Bkg || "", colText3, yPos)
    doc.line(lineText1, yPos + lineOffsetY, lineText1 + lineLenght, yPos + lineOffsetY)
    doc.line(lineText2, yPos + lineOffsetY, lineText2 + lineLenght, yPos + lineOffsetY)
    doc.line(lineText3, yPos + lineOffsetY, lineText3 + lineLenght, yPos + lineOffsetY)

    let contSizeFull = ""
    if (jobOrderData.ContSize) {
      if (["20", "2x20", "40", "45"].includes(jobOrderData.ContSize)) {
        const contSize = jobOrderData.ContSize === "20x2" ? "20" : jobOrderData.ContSize
        if (jobOrderData.ContHq === 1 && jobOrderData.ContTyp === "GP") {
          contSizeFull = `${contSize}HQ`
        } else {
          contSizeFull = `1x${jobOrderData.ContSizeFull}`
        }
      } else {
        contSizeFull = jobOrderData.ContSize
      }
      // if (jobOrderData.ContSize === "20") {
      //   contSizeFull = `1x${contSizeFull}`
      // }
    }
    yPos += lineHeightContent
    doc.setFont("THSarabun", "bold")
    doc.setFontSize(contentHeaderSize)
    doc.text("ส่งตู้", colHeader1, yPos)
    // doc.text("พักรับตู้", colHeader1, yPos)
    doc.text("ขนาดตู้", colHeader2, yPos)
    doc.text("สินค้า", colHeader3, yPos)
    doc.setFont("THSarabun", "normal")
    doc.setFontSize(contentSize)
    // const sts2Plc = jobOrderData.Sts2POIId?  msData.poiOb.find(p=>p.POIId === jobOrderData.Sts2POIId)?.Name || "": ""
    doc.text(jobOrderData.Loc || "", colText1, yPos)
    // doc.text(sts2Plc, colText1, yPos)
    doc.text(contSizeFull, colText2, yPos)
    doc.text(`${shipmentData.Job?.CmdyTyp || ""}${jobOrderData.Ref2 ? `/${jobOrderData.Ref2}` : ""}`, colText3, yPos)
    doc.line(lineText1, yPos + lineOffsetY, lineText1 + lineLenght, yPos + lineOffsetY)
    doc.line(lineText2, yPos + lineOffsetY, lineText2 + lineLenght, yPos + lineOffsetY)
    doc.line(lineText3, yPos + lineOffsetY, lineText3 + lineLenght, yPos + lineOffsetY)

    yPos += lineHeightContent
    doc.setFont("THSarabun", "bold")
    doc.setFontSize(contentHeaderSize)
    doc.text("คืนตู้", colHeader1, yPos)
    // doc.text("ส่งตู้", colHeader1, yPos)
    doc.text("เลขอ้างอิง", colHeader2, yPos)
    doc.text("TERM", colHeader3, yPos)
    doc.setFont("THSarabun", "normal")
    doc.setFontSize(contentSize)
    doc.text(jobOrderData.RtnPlc || "", colText1, yPos)
    doc.text(shipmentData.CusRefNo || "", colText2, yPos)
    doc.text(shipmentData.Ref1 || "", colText3, yPos)
    // doc.text(loc, colText1, yPos)
    doc.line(lineText1, yPos + lineOffsetY, lineText1 + lineLenght, yPos + lineOffsetY)
    doc.line(lineText2, yPos + lineOffsetY, lineText2 + lineLenght, yPos + lineOffsetY)
    doc.line(lineText3, yPos + lineOffsetY, lineText3 + lineLenght, yPos + lineOffsetY)

    yPos += lineHeightContent
    doc.setFont("THSarabun", "bold")
    doc.setFontSize(contentHeaderSize)
    // doc.text("พักคืน", colHeader1, yPos)
    doc.text("เบอร์ตู้", colHeader1, yPos)
    doc.text("หมายเลขซีล", colHeader2, yPos)
    doc.text("พนง.ขับรถ", colHeader3, yPos)
    doc.setFont("THSarabun", "normal")
    doc.setFontSize(contentSize)
    // doc.text(sts4Plc, colText1, yPos)
    doc.text(jobOrderData.ContNo || "", colText1, yPos)
    doc.text(jobOrderData.SealNo || "", colText2, yPos)
    doc.text(jobOrderData.DrvNm || "", colText3 + 0.05, yPos)
    doc.line(lineText1, yPos + lineOffsetY, lineText1 + lineLenght, yPos + lineOffsetY)
    doc.line(lineText2, yPos + lineOffsetY, lineText2 + lineLenght, yPos + lineOffsetY)
    doc.line(lineText3, yPos + lineOffsetY, lineText3 + lineLenght, yPos + lineOffsetY)

    yPos += lineHeightContent
    doc.setFont("THSarabun", "bold")
    doc.setFontSize(contentHeaderSize)
    doc.text("คำสั่งลาก", colHeader1, yPos)
    // doc.text("คืนตู้", colHeader1, yPos)
    // doc.text("พนง.ขับรถ", colHeader2, yPos)
    doc.text("ทะเบียน", colHeader3, yPos)
    doc.setFont("THSarabun", "normal")
    doc.setFontSize(contentSize)
    // doc.text(rtnPlc, colText1, yPos)
    doc.text(orderArr.join(" >> "), colText1 + 0.05, yPos)
    // doc.text(jobOrderData.DrvNm || "", colText2, yPos)
    doc.text(licNm, colText3, yPos)
    doc.line(lineText1, yPos + lineOffsetY, lineText1 + lineLenght2x, yPos + lineOffsetY)
    // doc.line(lineText2, yPos + lineOffsetY, lineText2 + lineLenght, yPos + lineOffsetY)
    doc.line(lineText3, yPos + lineOffsetY, lineText3 + lineLenght, yPos + lineOffsetY)


    yPos += lineHeightContent
    doc.setFont("THSarabun", "bold")
    doc.setFontSize(contentHeaderSize)
    doc.text("หมายเหตุ", colHeader1, yPos)
    doc.setFont("THSarabun", "normal")
    doc.setFontSize(contentSize)
    const rmks = [shipmentData.Rmk, jobOrderData.Rmk, jobOrderData.Ref1]
    doc.text(rmks.filter(Boolean).join(" | "), colText1 + 0.05, yPos)
    doc.line(lineText1, yPos + lineOffsetY, lineText1 + lineLenght3x, yPos + lineOffsetY)


    yPos += lineHeightContent

    // doc.text("ปิดรับตู้", colHeader2, yPos)
    // doc.text(jobOrderData.RtnDteEn ? dayjs(jobOrderData.RtnDteEn).format("DD/MM/YYYY HH:mm") : "", colText3, yPos)
    // doc.text("เลขจองตู้", colHeader2, yPos)
    // doc.text(jobOrderData.Ref1 || "", colText2 , yPos)
    return yPos
  }

  const drawReceipt = ({ startY, lineHeightContent, jobOrderData, shipmentData }) => {
    let yPos = startY
    doc.lines([[7.6, 0], [0, lineHeightContent * 3], [-7.6, 0], [0, lineHeightContent * 3 * -1]], startX - 0.1, yPos - 0.2, [1, 1], 'S', true)
    doc.setFont("THSarabun", "bold")
    doc.setFontSize(contentHeaderSize)
    doc.text("ข้อมูลใบเสร็จ", colHeader1, yPos)
    
    yPos += lineHeightContent - 0.1
    doc.setFont("THSarabun", "bold")
    doc.setFontSize(contentHeaderSize)
    doc.text("TAX ID : ", colHeader1, yPos)
    doc.text(jobOrderData.DXRmk || "", colText3 + 0.1, yPos + 0.05)
    doc.setFont("THSarabun", "normal")
    doc.setFontSize(contentSize)
    if (shipmentData.Job) {
      doc.text(`${shipmentData.Job?.RcptTaxId || ""} ${branchNoText(shipmentData.Job?.RcptNm || "", shipmentData.Job?.RcptBrchNo || 0)}`, colText1, yPos)
    }
    yPos += lineHeightContent - 0.1
    doc.setFont("THSarabun", "bold")
    doc.setFontSize(contentHeaderSize)
    doc.text("ชื่อใบเสร็จ : ", colHeader1, yPos)
    doc.setFont("THSarabun", "normal")
    doc.setFontSize(contentSize)
    if (shipmentData.Job) {
      doc.text(shipmentData.Job.RcptNm || "", colText1 + 0.1, yPos)
    }
    yPos += lineHeightContent - 0.1
    doc.setFont("THSarabun", "bold")
    doc.setFontSize(contentHeaderSize)
    doc.text("ที่อยู่: ", colHeader1, yPos)
    doc.setFont("THSarabun", "normal")
    doc.setFontSize(contentSize - 5)
    if (shipmentData.Job) {
      const addrs = doc.splitTextToSize(shipmentData.Job.RcptAddr, 7)
      doc.text(addrs.join("\n"), colText1 - 0.2, yPos)
    }

    return yPos
  }

  const drawSign = ({ startY, lineHeightContent, drvNm, fName }) => {
    let yPos = startY
    yPos += lineHeightContent * 2 + lineHeightContent / 4
    doc.setFont("THSarabun", "bold")
    doc.setFontSize(contentHeaderSize)
    const signCol = allBoxWidth / 3
    const signColPadding = 1
    const startSignCol = startX + 0.3
    yPos -= 0.2
    for (let i = 0; i < 3; i++) {
      doc.line(startSignCol + (signCol * i), yPos, startSignCol + (signCol * i) + signCol - signColPadding, yPos)
    }
    const texts = ["ผู้รับสินค้า (ตัวแทน)", "ผู้จ่ายงาน", "พนักงานขับรถ"]
    yPos += 0.2
    for (let i = 0; i < 3; i++) {
      doc.text(texts[i], startSignCol + (signCol * i) + (signCol - signColPadding) / 2, yPos, { align: "center" })
    }

    drvNm && doc.text(`(${drvNm})`, startSignCol + (signCol * 2) + (signCol - signColPadding) / 2, yPos + 0.2, { align: "center" })
    if (fName) {
      doc.setFontSize(contentHeaderSize + 3)
      doc.text(`${fName}`, startSignCol + (signCol * 1) + (signCol - signColPadding) / 2, yPos - 0.25, { align: "center" })
    }
  }

  let i = 0;
  for (const { jobOrderData, shipmentData, jobOrdIds, isPrintDateTime, fName } of printDataArr) {
    shipmentData.ShpmTypNm = msData.shipmentTypes.find(st => st.ShpmTypId === shipmentData.ShpmTypId)?.Abbr || ""
    jobOrderData.TakePlc = msData.poiObj[jobOrderData.TakePOIId] || ""
    jobOrderData.Loc = msData.poiObj[jobOrderData.LocPOIId] || ""
    jobOrderData.RtnPlc = msData.poiObj[jobOrderData.RtnPOIId] || ""
    let j = 0;
    let drvNm = ""
    if (jobOrderData.DrvId) {
      const drvObj = msData.driverObj[jobOrderData.DrvId]
      drvNm = `${drvObj?.FName || ""} ${drvObj?.LName || ""}`
    }
    jobOrderData.DrvNm = drvNm
    let licNm = ""
    if (jobOrderData.TukId) {
      const tukObj = msData.truckObj[jobOrderData.TukId]
      licNm = tukObj.LicNm
    }
    do {
      if (i + j !== 0) {
        doc.addPage()
      }
      let yPos = startY
      let xPos = startX
      yPos = startY
      xPos = startX

      yPos = drawHeader({
        startX: xPos,
        startY: yPos,
        jobOrderData,
        isPrintDateTime,
        title: "ใบปฏิบัติงาน",
        subTitle: "(ลูกค้า)"
      })
      const lineHeightContent = lineHeight + lineHeight / 2 - 0.04

      yPos = drawJobOrder({ startX: xPos, startY: yPos, jobOrderData, shipmentData, isPrintDateTime, lineHeightContent, licNm })

      yPos = drawReceipt({ startY: yPos, lineHeightContent, jobOrderData, shipmentData })

      drawSign({ startY: yPos, lineHeightContent, drvNm, fName })


      //------------------------------- Lower part -----------------------------------
      yPos = 5.85
      doc.setLineDashPattern([0.5, 3.2, 0.9, 3.2, 0.5])
      doc.line(0, yPos, 8.3, yPos)
      doc.setLineDashPattern()

      yPos += lineHeight * 2 -0.1

      yPos = drawHeader({
        startX: xPos,
        startY: yPos,
        jobOrderData,
        isPrintDateTime,
        title: "ใบปฏิบัติงาน",
        subTitle: "(ลานตู้)"
      })

      // const lineHeightContent = lineHeight + lineHeight / 2

      yPos = drawJobOrder({ startX: xPos, startY: yPos, jobOrderData, shipmentData, isPrintDateTime, lineHeightContent, licNm })

      yPos = drawReceipt({ startY: yPos, lineHeightContent, jobOrderData, shipmentData })

      drawSign({ startY: yPos, lineHeightContent, drvNm, fName })
      // yPos += lineHeightContent * 2 + lineHeightContent / 4
      // doc.setFont("THSarabun", "bold")
      // doc.setFontSize(contentHeaderSize)
      // // const signCol = allBoxWidth / 3
      // // const signColPadding = 1
      // // const startSignCol = startX + 0.3
      // yPos -= 0.2
      // for (let i = 0; i < 3; i++) {
      //   doc.line(startSignCol + (signCol * i), yPos, startSignCol + (signCol * i) + signCol - signColPadding, yPos)
      // }
      // // const texts = ["ผู้รับสินค้า (ตัวแทน)", "ผู้จ่ายงาน", "พนักงานขับรถ"]
      // yPos += 0.2
      // for (let i = 0; i < 3; i++) {
      //   doc.text(texts[i], startSignCol + (signCol * i) + (signCol - signColPadding) / 2, yPos, { align: "center" })
      // }

      // drvNm && doc.text(`(${drvNm})`, startSignCol + (signCol * 2) + (signCol - signColPadding) / 2, yPos + 0.2, { align: "center" })
      // if (fName) {
      //   doc.setFontSize(contentHeaderSize + 3)
      //   doc.text(`${fName}`, startSignCol + (signCol * 1) + (signCol - signColPadding) / 2, yPos - 0.25, { align: "center" })
      // }

      //------------------------------------------ End of 1st page ------------------------------------------


      // doc.addPage()
      // //------------------------------------------------ DrawExpense part ----------------------------------------------------
      // xPos = startX
      // yPos = startY
      // const contentSizeExp = 15
      // yPos = drawHeader({ startX: xPos, startY: yPos, jobOrderData, isPrintDateTime, title: "ใบสรุปค่าใช้จ่าย", subTitle: "" })

      // yPos += lineHeight
      // const printColValues = (header, value, xPos, yPos) => {
      //   console.log("printColValues:", { header, value, xPos, yPos })
      //   doc.setFont("THSarabun", "bold")
      //   doc.text(header, xPos, yPos)
      //   doc.setFont("THSarabun", "normal")
      //   doc.text(value, xPos + 0.8, yPos)
      //   doc.line(xPos + 0.8, yPos + lineOffsetY, xPos + 3.2, yPos + lineOffsetY)
      // }
      // doc.setFontSize(contentSizeExp)

      // const startContentY = yPos
      // const joColValues = [
      //   { header: "พนักงาน", value: drvNm ? `${drvNm} (${licNm})` : "" },
      //   { header: "ลูกค้า", value: shipmentData.CusNm || "" },
      //   { header: "งาน", value: shipmentData.Job?.JobSNm || "" },
      //   { header: "Job No.", value: shipmentData.JobNo || "" },
      //   { header: "Booking", value: shipmentData.Bkg || "" },
      //   { header: "รับตู้", value: jobOrderData.TakePlc || "" },
      //   { header: "คืนตู้", value: jobOrderData.RtnPlc || "" },
      //   { header: "ขนาดตู้", value: jobOrderData.ContSizeFull || "" },
      //   { header: "หมายเลขตู้", value: jobOrderData.ContNo || "" },
      //   { header: "หมายเลขซีล", value: jobOrderData.SealNo || "" },
      //   { header: "หมายเหตุ", value: jobOrderData.Rmk || "" },
      // ]

      // doc.setFont("THSarabun", "bold")
      // doc.text("ข้อมูลใบงาน:", startX, yPos)
      // yPos += lineHeight + 0.05
      // for (const joCol of joColValues) {
      //   printColValues(joCol.header, joCol.value, xPos, yPos)
      //   yPos += lineHeight
      // }
      // yPos += lineHeight
      // yPos = drawReceipt({ startY: yPos, lineHeightContent, jobOrderData, shipmentData })
      // // doc.setFont("THSarabun", "bold")
      // // doc.text("พนักงาน", colHeader1, yPos)
      // // doc.text("ทะเบียน", colHeader2, yPos)
      // // doc.text("งาน", colHeader3 - 0.5, yPos)
      // // doc.setFont("THSarabun", "normal")
      // // doc.text(drvNm, colText1, yPos)
      // // doc.text(licNm, colText2, yPos)
      // // doc.text(shipmentData.Job?.JobSNm || "", colText3 - 0.5 - 0.2, yPos)
      // // doc.line(lineText1, yPos + lineOffsetY, lineText1 + lineLenght, yPos + lineOffsetY)
      // // doc.line(lineText2, yPos + lineOffsetY, lineText2 + lineLenght - 0.5, yPos + lineOffsetY)
      // // doc.line(lineText3 - 0.5 - 0.2, yPos + lineOffsetY, lineText3 + lineLenght, yPos + lineOffsetY)
      // // yPos += lineHeightContent



      // const startExpTableX = pageSize[0] / 2
      // xPos = startExpTableX
      // yPos = startContentY
      // doc.setFontSize(contentSizeExp)
      // doc.setFont("THSarabun", "bold")
      // doc.text("ยอดเงินเบิก/รายการ :", xPos, yPos)
      // doc.setFont("THSarabun", "normal")

      // const expData = [
      //   { No: 1, Detail: "เงินเบิกล่วงหน้า", Sign: "+" },
      //   { No: 2, Detail: "ค่าผ่านท่า", Sign: "-" },
      //   { No: 3, Detail: "ค่ารับตู้/คืนตู้", Sign: "-" },
      //   { No: 4, Detail: "ยกตู้ดรอป", Sign: "-" },
      //   { No: 5, Detail: "ค่าทางด่วน", Sign: "-" },
      //   { No: 6, Detail: "ค่าล่วงเวลา", Sign: "-" },
      //   { No: 7, Detail: "อื่นๆ:", Sign: "-" },
      //   { No: 0, Detail: "รวม:", Sign: "" },
      // ]
      // const py = 0.1
      // const colNoW = 0.5
      // const colDetailW = 2.2
      // const colAmntW = 1
      // const dataBoxW = colNoW + colDetailW + colAmntW
      // const drawHeaderTable = (label, width, xPos, yPos) => {
      //   doc.text(label, xPos + width / 2, yPos, { align: "center" })
      //   // xPos += width
      //   return xPos + width
      // }

      // xPos = startExpTableX
      // yPos += lineHeight / 2
      // doc.setFillColor(blue[100])
      // doc.rect(xPos, yPos, dataBoxW, lineHeight + 0.1, "F")
      // yPos += lineHeight
      // xPos = drawHeaderTable("ลำดับ", colNoW, xPos, yPos)
      // xPos = drawHeaderTable("รายการ", colDetailW, xPos, yPos)
      // xPos = drawHeaderTable("จำนวนเงิน", colAmntW, xPos, yPos)
      // yPos += lineHeight + 0.1
      // // const linePY = 0.1
      // // const startLineY = yPos -linePY
      // // doc.line(xPos, startLineY, xPos + dataBoxW, startLineY)
      // for (const data of expData) {
      //   xPos = startExpTableX
      //   if (data.No === 0) {
      //     doc.setFont("THSarabun", "bold")
      //   }
      //   doc.text(data.No ? data.No.toString() : "", xPos + colNoW / 2, yPos, { align: "center" })
      //   xPos += colNoW
      //   doc.text(data.Detail, xPos + py, yPos)
      //   xPos += colDetailW
      //   doc.text(data.Sign, xPos + py, yPos)
      //   doc.text("บาท", xPos + colAmntW, yPos, { align: "right" })
      //   xPos = startExpTableX
      //   doc.line(xPos, yPos + 0.05, xPos + dataBoxW, yPos + 0.05)
      //   yPos += lineHeight
      // }
      // yPos += lineHeight / 2
      // doc.setFont("THSarabun", "bold")
      // xPos = startExpTableX
      // doc.text("ลงชื่อพนักงาน:", xPos, yPos)
      // doc.line(xPos + 0.9, yPos + lineOffsetY, xPos + 2.35, yPos + lineOffsetY)
      // xPos = startExpTableX + colNoW + colDetailW
      // doc.text("คงเหลือ", xPos + 0.15, yPos, { align: "right" })
      // doc.text("บาท", xPos + colAmntW, yPos, { align: "right" })
      // doc.line(xPos + 0.15, yPos + lineOffsetY, xPos + colAmntW - 0.3, yPos + lineOffsetY)
      // yPos += 0.03
      // doc.line(xPos + 0.15, yPos + lineOffsetY, xPos + colAmntW - 0.3, yPos + lineOffsetY)


      // //------------------------------- Lower part -----------------------------------
      // yPos = 5.85
      // xPos = startX
      // doc.setLineDashPattern([0.5, 3.2, 0.9, 3.2, 0.5])
      // doc.line(0, yPos, 8.3, yPos)
      // doc.setLineDashPattern()

      // yPos += lineHeight * 1.5

      // yPos = drawHeader({
      //   startX: xPos,
      //   startY: yPos,
      //   jobOrderData,
      //   isPrintDateTime,
      //   title: "ใบปฏิบัติงาน",
      //   subTitle: "(นำกลับ)"
      // })
      // // const lineHeightContent = lineHeight + lineHeight / 2
      // yPos = drawJobOrder({ 
      //   startX: xPos, 
      //   startY: yPos, 
      //   lineHeightContent: lineHeightContent - 0.05,
      //   jobOrderData, shipmentData, isPrintDateTime, licNm })

      // // yPos = drawReceipt({ startY: yPos, lineHeightContent, jobOrderData, shipmentData })
      // yPos -= 0.15

      // const startBoxX = startX - 0.2
      // const startBoxY = yPos
      // const boxWidth = allBoxWidth / 4
      // const col1 = startBoxX + 0.2
      // const col2 = col1 + boxWidth
      // const col3 = col2 + boxWidth
      // const col4 = col3 + boxWidth
      // const headerCol1 = col1 + (boxWidth / 2)
      // const headerCol2 = col2 + (boxWidth / 2)
      // const headerCol3 = col3 + (boxWidth / 2)
      // const headerCol4 = col4 + (boxWidth / 2)

      // const boxHeight = (lineHeightContent * 4)
      // doc.lines([[allBoxWidth, 0], [0, boxHeight], [-allBoxWidth, 0]], startBoxX, startBoxY, [1, 1], 'S', true)
      // yPos += 0.3
      // doc.text("เริ่มงาน", headerCol1, yPos, { align: "center" })
      // doc.text("รับตู้/สินค้า", headerCol2, yPos, { align: "center" })
      // doc.text("ส่งตู้/สินค้า", headerCol3, yPos, { align: "center" })
      // doc.text("คืนตู้", headerCol4, yPos, { align: "center" })
      // const yCheckbox = yPos - 0.17
      // const checkBoxWidth = 0.2
      // const cornerRadius = 0.04

      // // doc.roundedRect(headerCol1 -0.5, yCheckbox, checkBoxWidth, checkBoxWidth, cornerRadius, cornerRadius)
      // doc.roundedRect(headerCol2 - 0.6, yCheckbox, checkBoxWidth, checkBoxWidth, cornerRadius, cornerRadius)
      // doc.roundedRect(headerCol3 - 0.6, yCheckbox, checkBoxWidth, checkBoxWidth, cornerRadius, cornerRadius)
      // doc.roundedRect(headerCol4 - 0.4, yCheckbox, checkBoxWidth, checkBoxWidth, cornerRadius, cornerRadius)

      // // doc.text(`✔`, headerCol2 - 0.4 + 0.05, yCheckbox + 0.15)
      // const contStses = jobOrderData.ContStses || []
      // doc.setFont("THSarabun", "bold")
      // if (contStses.find(cs => cs.ContStsId === 1 && cs.DrvId === jobOrderData.DrvId)) {
      //   doc.text(`X`, headerCol2 - 0.6 + 0.05, yCheckbox + 0.15)
      // }
      // if (contStses.find(cs => cs.ContStsId === 3 && cs.DrvId === jobOrderData.DrvId)) {
      //   doc.text(`X`, headerCol3 - 0.6 + 0.05, yCheckbox + 0.15)
      // }
      // if (contStses.find(cs => cs.ContStsId === 5 && cs.DrvId === jobOrderData.DrvId)) {
      //   doc.text(`X`, headerCol4 - 0.4 + 0.05, yCheckbox + 0.15)
      // }
      // yPos += lineHeightContent - 0.15

      // const startBoxYPos = yPos
      // for (let col = 0; col < 4; col++) {
      //   yPos = startBoxYPos + 0.05
      //   doc.setFont("THSarabun", "normal")
      //   doc.setFontSize(contentHeaderSize)
      //   const colStart = startBoxX + (boxWidth * col) + 0.1
      //   const lineStart = colStart + 0.6
      //   const lineEnd = colStart + boxWidth - 0.2
      //   doc.text(col === 0 ? "เวลาออก: " : "เวลาถึง: ", colStart, yPos)
      //   doc.line(lineStart, yPos + lineOffsetY, lineEnd, yPos + lineOffsetY)
      //   yPos += lineHeightContent
      //   doc.text("เลขไมล์หัว: ", colStart, yPos)
      //   doc.line(lineStart, yPos + lineOffsetY, lineEnd, yPos + lineOffsetY)
      //   yPos += lineHeightContent
      //   // doc.text("เลขไมล์หาง: ", colStart, yPos)
      //   // doc.line(lineStart, yPos + lineOffsetY, lineEnd, yPos + lineOffsetY)
      //   // yPos += lineHeightContent
      //   doc.text("%แบตเตอรี: ", colStart, yPos)
      //   doc.line(lineStart, yPos + lineOffsetY, lineEnd, yPos + lineOffsetY)
      //   if (col !== 0) {
      //     const endCol = startBoxX + (boxWidth * col)
      //     doc.line(endCol, startBoxY, endCol, startBoxY + boxHeight)
      //   }
      // }

      // yPos += lineHeightContent * 2
      // doc.setFont("THSarabun", "bold")
      // doc.setFontSize(contentHeaderSize)
      // // const signCol = allBoxWidth / 3
      // // const signColPadding = 1
      // // const startSignCol = startX + 0.3
      // yPos -= 0.2
      // for (let i = 0; i < 3; i++) {
      //   doc.line(startSignCol + (signCol * i), yPos, startSignCol + (signCol * i) + signCol - signColPadding, yPos)
      // }
      // // const texts = ["ผู้รับสินค้า (ตัวแทน)", "ผู้จ่ายงาน", "พนักงานขับรถ"]
      // yPos += 0.2
      // for (let i = 0; i < 3; i++) {
      //   doc.text(texts[i], startSignCol + (signCol * i) + (signCol - signColPadding) / 2, yPos, { align: "center" })
      // }

      // drvNm && doc.text(`(${drvNm})`, startSignCol + (signCol * 2) + (signCol - signColPadding) / 2, yPos + 0.2, { align: "center" })
      // if (fName) {
      //   doc.setFontSize(contentHeaderSize + 3)
      //   doc.text(`${fName}`, startSignCol + (signCol * 1) + (signCol - signColPadding) / 2, yPos - 0.25, { align: "center" })
      // }


      //------------------------------ end of job order print ------------------------------
      yPos += 0.65
      j++
      i++
    } while (j < jobOrdIds.length)
  }




  const blob = new Blob([doc.output('blob')], { type: 'application/pdf' });
  const blobUrl = URL.createObjectURL(blob);

  // Open in new tab
  window.open(blobUrl, '_blank');

  // Clean up memory after a small delay

  ;
  // window.open(doc.autoPrint() , '_blank')
  // doc.autoPrint({variant: 'non-conform'});
  // window.open(doc.output('bloburl'), '_blank')
}